//const BASE_URL = 'https://edusuite.trackschoolbus.com/';
//const BASE_URL_LOGIN = 'https://app.klickitapp.com/';
//const BASE_URL ='https://app.klickitapp.com/';

//const BASE_URL ='https://app.edsys.in/';
const BASE_URL = "https://stage.edsys.in/";
const PATH = "api/studentapp/";
const NEW_BASE_URL = "https://stage.edsys.in:3014/api/student/";

const NODE_URL = "https://app.edsys.in:3000/";
// const NODE_PATH = NODE_URL + "/api/studentapp/";
const PATHs = "api/student/";
const ApiConfig = {
  BASE_URL: BASE_URL,
  NODE_URL: NODE_URL,
  //login url

  LOGIN_API: NODE_URL + PATHs + "login",

  OTP_LOGIN_API: NODE_URL + PATHs + "login/otp_login",
  // OTP_LOGIN_API:'http://carrental.vehicletracking.qa/api/vendor/login',
  VERIFY_OTP_API: NODE_URL + PATHs + "login/verifyotp",
  SOCIAL_LOGIN: BASE_URL + PATH + "login/social_login",
  //base url
  ATTENDANCE_BY_DATE_API: NODE_URL + PATHs + "attendancebydate",
  USERT_PROFILE: NODE_URL + PATHs + "profile",
  DASHBOARD_API: NODE_URL + PATHs + "dashboard",

  SYLLABUS_API: NODE_URL + PATHs + "syllabus",

  TEACHER_LIST_API: NODE_URL + PATHs + "teacher/list",
  TEACHER_DETAILS_API: NODE_URL + PATHs + "teacher/view",

  ACTIVITY_COUNT_API: NODE_URL + PATHs + "activitycount",

  TODAYS_ASSESSMENT_LIST_API: NODE_URL + PATHs + "assessment/today",
  MONTHLY_LESSON_LIST_API: NODE_URL + PATHs + "syllabus/lesson",
  UPCOMING_ASSESSMENT_LIST_API: NODE_URL + PATHs + "assessment/upcoming",
  ASSESSMENT_HISTORY_LIST_API: NODE_URL + PATHs + "assessment/history",
  ASSESSMENT_DETAILS_API: NODE_URL + PATHs + "assessment/details",
  ASSESSMENT_ALL_DETAILS_API: NODE_URL + PATHs + "assessment/alldetails",
  ASSESSMENT_SUBMIT_API: NODE_URL + PATHs + "assessment/submit",

  ASSIGNMENT_HISTORY_LIST_API: NODE_URL + PATHs + "assignment/history",
  TODAYS_ASSIGNMENT_LIST_API: NODE_URL + PATHs + "assignment/pending",
  ASSIGNMENT_UPCOMING_API: NODE_URL + PATHs + "assignment/upcoming",

  // ASSIGNMENT_HISTORY_LIST_API: BASE_URL + PATH + "assignment/list/history",
  // TODAYS_ASSIGNMENT_LIST_API: BASE_URL + PATH + "assignment/list/today",
  // ASSIGNMENT_UPCOMING_API: BASE_URL + PATH + "assignment/list/upcoming",
  ASSIGNMENT_SAVE: NODE_URL + PATHs + "assignment/save",
  ASSIGNMENT_SUBMISSION: NODE_URL + PATHs + "assignment/assignments/submit",
  ASSIGNMENT_DETAILS: NODE_URL + PATHs + "assignment/assignments/details",

  // ELEARNING_SUBJECT: BASE_URL + PATH + "edirectory/subjects",
  ELEARNING_SUBJECT_NEW: NODE_URL + PATHs + "edirectory/subjects",
  ELEARNING_LIST_NEW: NODE_URL + PATHs + "edirectory/list",
  ELEARNING_PDF_DETAILS: NODE_URL + PATHs + "edirectory/details",
  PROFILE: NODE_URL + PATHs + "profile",

  // DAILY_TIMETABLE: NODE_URL + PATHs + "timetable/daily",

  // WEEKLY_TIMETABLE: NODE_URL + PATHs + "timetable/weekly",

  MONTHLY_TIMETABLE: NODE_URL + PATHs + "timetable/monthly",

  PROFILE_EDIT: NODE_URL + PATHs + "/profile/editprofilepic",

  UPDATE_PROFILE_URL: NODE_URL + PATHs + "profile/editprofilepic?",
  ASSESSMENT_RESULT_API:
    BASE_URL + PATH + "assessment/resultdownload/answersheet?",
  STUDENT_LANGUAGE: NODE_URL + PATHs + "language",
  STUDENT_THEME: NODE_URL + PATHs + "theme",
  // SUBJECT_LESSON_API: BASE_URL + PATH + "subject/lessons",
  SUBJECT_LESSON_API: NODE_URL + PATHs + "subject/lessons",
  GET_ATTENDANCE_BY_DATE_API: NODE_URL + PATHs + "attendancebydate",
  WALLET_BALANCE_API: NODE_URL + PATHs + "wallet/balance",
  WALLET_STATEMENT_API: NODE_URL + PATHs + "wallet/statement",
  WALLET_NOTIFICATION_API: NODE_URL + PATHs + "wallet/statement/notification",
  // WALLET_ADD_MONEY_API: BASE_URL + PATH + "wallet/addmoney",
  WALLET_ADD_MONEY_API: NODE_URL + PATHs + "wallet/addmoney",

  // WALLET_SAVE_TRANSACTION_API: BASE_URL + PATH + "wallet/savetransaction",
  WALLET_SAVE_TRANSACTION_API: NODE_URL + PATHs + "wallet/savetransaction",
  BYPASS_LOGIN_API: BASE_URL + PATH + "reactlogin/bypass",
  //newly created apis
  MY_DIARY: NODE_URL + PATHs + "diary/list",
  COMMENT_LIST: NODE_URL + PATHs + "diary/comment/list",
  COMMENT_LIKE: NODE_URL + PATHs + "diary/like",
  COMMENT_AND_REPLAY: NODE_URL + PATHs + "diary/comment ",

  ROUTE: NODE_URL + PATHs + "route",
  LIVE_TRACK: NODE_URL + PATHs + "track",
  AUTHORIZED_PERSON: NODE_URL + PATHs + "gaurdians",

  FEED_LIST: NODE_URL + PATHs,
  FEED_DETAILS: NODE_URL + PATHs + "feed/view",
  FEED_ADD: NODE_URL + PATHs + "feed/addfeed",
  FEED_EDIT: NODE_URL + PATHs + "feed/edit",
  FEED_COMMENTS: NODE_URL + PATHs,
  FEED_DETAILSS: NODE_URL + PATHs,

  FORUM_LIST: NODE_URL + PATHs + "forum/list?",
  FORUM_COMMENT_LIST: NODE_URL + PATHs + "forum/listComment",
  FORUM_CREATE: NODE_URL + PATHs + "forum/create",
  FORUM_CATEGORY: NODE_URL + PATHs + "forum/category",
  FROUM_EDIT: NODE_URL + PATHs + "forum/edit",
  COMMENT_EDIT: NODE_URL + PATHs + "comment/edit",
  NOTIFICATION: NODE_URL + PATHs + "notification/user_history",

  ANNOUNCEMENT: NODE_URL + PATHs + "annoucement/list",
  ANNOUNCEMENT_DETAILS: NODE_URL + PATHs + "annoucement/details",
  ATTENDANCE_DATE_MONTH_YEAR: NODE_URL + PATHs + "attendance_by_date",
  ATTENDANCE_LIST: NODE_URL + PATHs + "leave/list",
  LEAVE_VIEW: NODE_URL + PATHs + "leave/view",
  LEAVE_CANCEL: NODE_URL + PATHs + "leave/cancel",
  APPLY_LEAVE: NODE_URL + PATHs + "leave/apply",
  UPDATE_LEAVE: NODE_URL + PATHs + "leave/update",
  //wallet
  WALLET_DATAS: NODE_URL + PATHs + "wallet/transaction",
  WALLET_DETAILS: NODE_URL + PATHs + "succeedTransaction",

  // SYLLABUS_DETAIL_API: NODE_URL + PATHs + "assessment/subjects/detail",

  //TODOLIST/////
  TODO_TODAYLIST: NODE_URL + PATHs + "todaytodolist",
  TODO_DELAYEDLIST: NODE_URL + PATHs + "tododelayed",
  TODO_UPCOMINGLIST: NODE_URL + PATHs + "todosupcoming",
  TODO_WEEKLIST: NODE_URL + PATHs + "todosthisweek",
  TODO_MONTHLIST: NODE_URL + PATHs + "todosthismonth",
  TODO_CREATE: NODE_URL + PATHs + "todo/add",
  TODO_DETAILS: NODE_URL + PATHs + "todo/details",
  TODO_UPDATE: NODE_URL + PATHs + "/todo/update",
  TODO_DELETE: NODE_URL + PATHs + "/todo/delete",

  MY_BOOK: NODE_URL + PATHs + "library/mybooks",
  MY_BOOK_HISTORY: NODE_URL + PATHs + "library/bookhistory",
  MY_BOOK_QUEUE: NODE_URL + PATHs + "library/myqueue",
  MY_BOOK_SEARCH: NODE_URL + PATHs + "library/searchbook",
  SCHOOL_EVENT: NODE_URL + PATHs + "events",
};

export default ApiConfig; //{ ApiConfig, BASE_URL, BASE_URL_LOGIN };
